/* ============================================
   COLLECTION SWATCH IMAGE SWAP
   (PRIMARY + SECONDARY IMAGE SUPPORT)
============================================ */

(() => {
  const STOREFRONT_TOKEN = 'b64a27392f594c5397280daf29455a9b';
  const SHOP_DOMAIN = 'mitchell-black.myshopify.com';
  const API_VERSION = '2023-10';

  const imageCache = {};
  let activeRequest = false;

  async function fetchProductImages(handle) {
    if (imageCache[handle]) return imageCache[handle];

    const query = `
      query ($handle: String!) {
        product(handle: $handle) {
          images(first: 2) {
            nodes {
              url
            }
          }
        }
      }
    `;

    try {
      const res = await fetch(
        `https://${SHOP_DOMAIN}/api/${API_VERSION}/graphql.json`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
          },
          body: JSON.stringify({ query, variables: { handle } })
        }
      );

      const json = await res.json();
      const images = json?.data?.product?.images?.nodes || [];

      const result = {
        primary: images[0]?.url || null,
        secondary: images[1]?.url || null
      };

      imageCache[handle] = result;
      return result;
    } catch (err) {
      console.error('Error fetching product images:', err);
      return null;
    }
  }

  function swapImages(swatch, images) {
    if (!images?.primary) return;

    const card = swatch.closest('.grid__item, .product-grid-item');
    if (!card) return;

    /* Primary image (square ratio) */
    const primaryImg = card.querySelector(
      '.grid__image-ratio.grid__image-ratio--square img'
    );

    if (primaryImg) {
      primaryImg.src = images.primary;
      primaryImg.srcset = images.primary;
    }

    /* Secondary hover image */
    if (images.secondary) {
      const secondaryImg = card.querySelector(
        '.grid-product__secondary-image.small--hide img'
      );

      if (secondaryImg) {
        secondaryImg.src = images.secondary;
        secondaryImg.srcset = images.secondary;
      }
    }

    /* Update product link */
    const link = swatch.dataset.link;
    if (link) {
      const productLink = card.querySelector('.grid-product__link');
      if (productLink) productLink.href = link;
    }

    /* Active swatch state */
    card.querySelectorAll('.collection_swatch')
      .forEach(s => s.classList.remove('active'));
    swatch.classList.add('active');
  }

  /* Click handler */
  document.addEventListener('click', async (e) => {
    const swatch = e.target.closest('.collection_swatch');
    if (!swatch) return;

    const handle = swatch.dataset.handle;
    if (!handle || activeRequest) return;

    activeRequest = true;

    const images = await fetchProductImages(handle);
    if (images) swapImages(swatch, images);

    activeRequest = false;
  });

})();
